module.exports = __webpack_public_path__ + "static/media/logo-white.953b0a33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-white.svg
// module id = 643
// module chunks = 0